/* RESPONSIBLE TEAM: team-proactive-support */
import CalendarSettings from 'embercom/models/calendar-settings';

export default CalendarSettings.extend();
